import { aspectRatio as ar } from "../../../common/parameters";
import { ExperienceTheme, IPlan, ITask } from "../../../common/types";

export const iconWidth = 72 * 1.6;
export const padding = 36;

const easterDistanceX = 115;
const easterDistanceY = 126;
const easterStartY = 116 / 1.6;
const eggWidth = 96 / 0.8;

export const easterDestinationPositions = [
    { x: 545.6, y: 259.5 },
    { x: 501.4, y: 266.1 },
    { x: 575.2, y: 260.8 },
    { x: 520.3, y: 265.3 },
    { x: 560, y: 268.2 },
    { x: 535.2, y: 273.7 },
    { x: 508.8, y: 280.2 },
    { x: 475, y: 271.8 },
    { x: 488.5, y: 275.9 },
    { x: 584.5, y: 274.9 },
];

export const christmasDestinationPositions = [
    { x: 704 - 56, y: 511 - 56 },
    { x: 814 - 56, y: 497 - 56 },
    { x: 498 - 56, y: 500 - 56 },
    { x: 487 - 56, y: 386 - 56 },
    { x: 682 - 56, y: 340 - 56 },
    { x: 549 - 56, y: 280 - 56 },
    { x: 618 - 56, y: 93 - 56 },
    { x: 654 - 56, y: 218 - 56 },
    { x: 584 - 56, y: 590 - 56 },
    { x: 605 - 56, y: 435 - 56 },
];

export const christmasStartingPositions = [
    { x: 1044 - 52, y: 111 - 64 },
    { x: 1165 - 52, y: 217 - 64 },
    { x: 1013 - 52, y: 343 - 64 },
    { x: 1184 - 52, y: 410 - 64 },
    { x: 949 - 52, y: 524 - 64 },
    { x: 275 - 52, y: 511 - 64 },
    { x: 81 - 52, y: 399 - 64 },
    { x: 364 - 52, y: 328 - 64 },
    { x: 208 - 52, y: 251 - 64 },
    { x: 859 - 52, y: 217 - 64 },
];



export const getTaskPositions = (tasks: (ITask | ITask[] | undefined)[], experienceTheme: ExperienceTheme) => {
    if (experienceTheme === ExperienceTheme.Easter) {
        const totalTasks = tasks.filter(task => !!task).length;
        const positions: ({x: number, y: number })[] = [];
        let nth = 0;
        tasks.forEach((task, index) => {
            if (!task) return;
            positions[index] = {
                x: ar.width / 2 + (totalTasks * easterDistanceX - (easterDistanceX - eggWidth)) / 2
                    - nth * easterDistanceX - easterDistanceX,
                y: easterStartY + (nth % 2 === 0 ? easterDistanceY : 0),
            };
            nth++;
        });
        return positions;
    } else if (experienceTheme === ExperienceTheme.Christmas) {
        const positions: ({x: number, y: number })[] = [];
        tasks.forEach((task, index) => {
            if (!task) return;
            positions[index] = christmasStartingPositions[index];
            nth++;
        });
        return positions;
    }
    const positions = [];
    const rightPartTotal = [0, 1, 2, 3].filter(index => !!tasks[index]).length;
    let nth = 0;
    switch (rightPartTotal) {
        case 1:
            [0, 1, 2, 3].forEach(index => {
                if (tasks[index]) {
                    positions[index] = {
                        x: ar.width / 4 * 3 + padding,
                        y: ar.height / 2 - iconWidth / 2,
                    }
                }
            });
            break;
        case 2:
            [0, 1, 2, 3].forEach(index => {
                if (tasks[index]) {
                    positions[index] = {
                        x: ar.width / 4 * 3 + padding,
                        y: ar.height / 4 + nth * (ar.height / 2 - iconWidth),
                    }
                    nth++;
                }
            });
            break;
        case 3:
            [0, 1, 2, 3].forEach(index => {
                if (tasks[index]) {
                    positions[index] = {
                        x: ar.width / 4 * 3 - iconWidth + (nth % 2 === 1 ? (iconWidth + padding) : 0),
                        y: nth === 0
                            ? ar.height / 4 - padding - iconWidth
                            : nth === 1
                                ? ar.height / 2 - iconWidth / 2
                                : ar.height / 4 * 3 + padding
                    }
                    nth++;
                }
            });
            break;
        case 4:
            [0, 1, 2, 3].forEach(index => {
                if (tasks[index]) {
                    positions[index] = {
                        x: ar.width / 4 * 3 - iconWidth + ((nth === 1 || nth === 2) ? (iconWidth + padding) : 0),
                        y:
                            ar.height / 4
                            + (nth > 1 ? ar.height / 2 : 0)
                            + (nth === 0
                                ? (-padding - iconWidth)
                                : nth === 2
                                    ? (-iconWidth)
                                    : nth === 3
                                        ? padding
                                        : 0
                            )
                    }
                    nth++;
                }
            });
            break;
        default:
            break;
    }
    const leftPartTotal = [5, 6, 7, 8].filter(index => !!tasks[index]).length;
    nth = 0;
    switch (leftPartTotal) {
        case 1:
            [5, 6, 7, 8].forEach(index => {
                if (tasks[index]) {
                    positions[index] = {
                        x: ar.width / 4 - padding - iconWidth,
                        y: ar.height / 2 - iconWidth / 2,
                    }
                }
            });
            break;
        case 2:
            [5, 6, 7, 8].forEach(index => {
                if (tasks[index]) {
                    positions[index] = {
                        x: ar.width / 4 - padding - iconWidth,
                        y: ar.height / 4 + (-(nth - 1)) * (ar.height / 2 - iconWidth),
                    }
                    nth++;
                }
            });
            break;
        case 3:
            [5, 6, 7, 8].forEach(index => {
                if (tasks[index]) {
                    positions[index] = {
                        x: ar.width / 4 - (nth % 2 === 1 ? (iconWidth + padding) : 0),
                        y: nth === 2
                            ? ar.height / 4 - padding - iconWidth
                            : nth === 1
                                ? ar.height / 2 - iconWidth / 2
                                : ar.height / 4 * 3 + padding
                    }
                    nth++;
                }
            });
            break;
        case 4:
            [5, 6, 7, 8].forEach(index => {
                if (tasks[index]) {
                    positions[index] = {
                        x: ar.width / 4 - ((nth === 1 || nth === 2) ? (iconWidth + padding) : 0),
                        y: nth === 0
                            ? (ar.height / 4 * 3 + padding)
                            : nth === 1
                                ? ar.height / 4 * 3 - iconWidth
                                : nth === 2
                                    ? ar.height / 4
                                    : ar.height / 4 - padding- iconWidth
                           
                    }
                    nth++;
                }
            });
            break;
        default:
            break;
    }
    if (tasks[4]) {
        positions[4] = {
            x: ar.width / 2 - iconWidth / 2,
            y: ar.height / 4 * 3 + padding,
        }
    }
    if (tasks[9]) {
        positions[9] = {
            x: ar.width / 2 - iconWidth / 2,
            y: ar.height / 4 - iconWidth - padding,
        }
    }
    return positions;
}

export const getCompletedScreens = (completedTaskIndexes: (number | null)[], plan: IPlan) => {
    const result: number[] = [];
    completedTaskIndexes.forEach(taskIndex => {
        const taskId = plan.tasks.find((task, index) => index === taskIndex)!.id;
        const position = plan.experience.positions.indexOf(taskId);
        result.push(position);
    });
    return result;
}

const easterSupportedLanguages = ["en", "hu", "it", "lt", "de", "et", "ro", "nl", "hr", "pl", "ca", "el", "tr"];

export const getEasterLocale = (locale: string) => {
    if (easterSupportedLanguages.includes(locale)) {
        return locale;
    }
    return "en";
}

export const christmasIcons = [
    "ball",
    "candybar",
    "santa",
    "candle",
    "ginger",
    "sock",
    "star",
    "bell",
    "present",
    "raindeer",
];
